import { IconDefinition, IconName, IconPack } from '@fortawesome/fontawesome-svg-core';

const xIconApplePay: IconDefinition = {
  prefix: 'fal',
  iconName: 'apple-pay',
  icon: [
    47,
    20,
    [],
    '',
    'M8.6,2.61c-.69,.9-1.48,1.29-2.36,1.19-.1-.9,.2-1.74,.89-2.53,.59-.79,1.35-1.21,2.29-1.27,.1,.95-.17,1.82-.81,2.61Zm.81,1.42c1.28,.11,2.24,.66,2.88,1.66h-.07c-1.13,.79-1.67,1.84-1.62,3.16,0,.26,.02,.53,.07,.79,.05,.26,.11,.49,.18,.67,.07,.18,.16,.37,.26,.55s.21,.34,.33,.47c.12,.13,.23,.25,.33,.36,.1,.11,.21,.18,.33,.24,.12,.05,.22,.11,.3,.16,.07,.05,.14,.09,.18,.12,.05,.03,.07,.04,.07,.04-.15,.74-.49,1.53-1.03,2.37-.89,1.37-1.7,2.06-2.44,2.06-.34,0-.76-.11-1.26-.32-.49-.21-.94-.32-1.33-.32s-.84,.11-1.33,.32c-.49,.21-.89,.32-1.18,.32-.74,.05-1.58-.66-2.51-2.13-.74-1.16-1.23-2.49-1.48-3.99-.25-1.5-.07-2.97,.52-4.39,.74-1.37,1.8-2.08,3.17-2.13,.3,0,.62,.07,.96,.2,.34,.13,.66,.26,.96,.4,.3,.13,.52,.2,.66,.2s.57-.14,1.26-.43c.69-.29,1.28-.41,1.77-.36Zm7.38-2.85h5.39c.94,0,1.76,.21,2.47,.63,.71,.42,1.28,1.01,1.7,1.78,.42,.76,.63,1.65,.63,2.65,0,1.48-.46,2.69-1.37,3.64-.91,.95-2.08,1.42-3.51,1.42h-3.1v5.22h-2.22V1.19Zm2.22,1.98v6.09h2.58c.98,0,1.75-.26,2.29-.79,.54-.53,.81-1.28,.81-2.25s-.27-1.73-.81-2.25-1.3-.79-2.29-.79h-2.58Zm12.03,13.52c-1.03,0-1.88-.3-2.55-.91-.66-.61-1-1.41-1-2.41,0-2,1.33-3.11,3.99-3.32l2.81-.16v-.87c0-1.27-.71-1.9-2.14-1.9-1.23,0-1.94,.53-2.14,1.58h-1.99c0-.69,.18-1.29,.55-1.82,.37-.53,.87-.94,1.51-1.23,.64-.29,1.35-.43,2.14-.43,1.28,0,2.3,.33,3.06,.99,.76,.66,1.14,1.54,1.14,2.65v7.67h-2.07v-1.82h-.07c-.64,1.32-1.72,1.98-3.25,1.98Zm.59-1.82c.74,0,1.37-.24,1.88-.71,.52-.47,.78-1.05,.78-1.74v-.87l-2.51,.16c-1.43,.05-2.14,.58-2.14,1.58,0,.32,.09,.59,.26,.83,.17,.24,.41,.42,.7,.55,.3,.13,.64,.2,1.03,.2Zm7.53,5.85h-.81v-1.9c.25,.05,.47,.08,.66,.08,.94,0,1.55-.53,1.85-1.58l.22-.71-3.77-11.23h2.29l2.66,9.09h.07l2.58-9.09h2.29l-3.91,11.78c-.44,1.37-.96,2.31-1.55,2.81-.59,.5-1.45,.75-2.58,.75Z',
  ],
};

export const xIconFacebook: IconDefinition = {
  prefix: 'fal',
  iconName: 'facebook',
  icon: [
    18,
    18,
    [],
    '',
    'M0,10C0,15.523 4.477,20 10,20C15.523,20 20,15.523 20,10C20,4.477 15.523,0 10,0C4.477,0 0,4.477 0,10ZM10,5C12.75,5 15,7.25 15,10C15,12.5 13.188,14.625 10.688,15L10.688,11.438L11.875,11.438L12.125,10L10.75,10L10.75,9.063C10.75,8.688 10.938,8.313 11.563,8.313L12.188,8.313L12.188,7.063C12.188,7.063 11.625,6.938 11.063,6.938C9.938,6.938 9.188,7.625 9.188,8.875L9.188,10L7.938,10L7.938,11.438L9.188,11.438L9.188,14.938C6.813,14.563 5,12.5 5,10C5,7.25 7.25,5 10,5Z',
  ],
};

export const xIconInstagram: IconDefinition = {
  prefix: 'fal',
  iconName: 'instagram',
  icon: [
    48,
    48,
    [],
    '',
    'M29.1,13.8L18.9,13.8C17.7,14 17.1,14.1 16.7,14.3C16.1,14.5 15.6,14.8 15.2,15.2C14.8,15.6 14.7,15.9 14.5,16.3C14.4,16.4 14.4,16.5 14.3,16.7C14.3,16.8 14.3,16.8 14.2,16.9C14,17.3 13.8,17.9 13.8,18.9L13.8,29.1C14,30.3 14.1,30.9 14.3,31.3C14.5,31.9 14.8,32.4 15.2,32.8C15.6,33.2 15.9,33.3 16.3,33.5C16.4,33.6 16.5,33.6 16.7,33.7C16.8,33.7 16.8,33.7 16.9,33.8C17.3,34 17.9,34.2 18.9,34.2L29.1,34.2C30.3,34.1 30.9,33.9 31.3,33.8C31.9,33.6 32.4,33.4 32.8,32.9C33.2,32.5 33.3,32.2 33.5,31.8C33.6,31.7 33.6,31.6 33.7,31.4C33.7,31.3 33.7,31.3 33.8,31.2C34,30.8 34.2,30.2 34.2,29.2L34.2,18.9C34.1,17.7 33.9,17.1 33.8,16.7C33.6,16.1 33.4,15.6 32.9,15.2C32.5,14.8 32.2,14.7 31.8,14.5C31.7,14.4 31.6,14.4 31.4,14.3C31.3,14.3 31.3,14.2 31.2,14.2C30.7,14 30.1,13.8 29.1,13.8ZM24,17.5C27.6,17.5 30.4,20.5 30.4,24C30.4,27.5 27.6,30.4 24,30.4C20.4,30.4 17.5,27.6 17.5,24C17.5,20.4 20.4,17.5 24,17.5ZM32.1,17.4C32.1,18.2 31.4,18.9 30.6,18.9C29.8,18.9 29.1,18.2 29.1,17.4C29.1,16.6 29.8,15.9 30.6,15.9C31.4,15.9 32.1,16.6 32.1,17.4ZM24,28.2C26.2,28.2 28.2,26.2 28.2,24C28.2,21.6 26.2,19.8 24,19.8C21.6,19.8 19.8,21.8 19.8,24C19.8,26.4 21.8,28.2 24,28.2ZM0,24C0,37.3 10.7,48 24,48C37.3,48 48,37.3 48,24C48,10.7 37.3,0 24,0C10.7,0 0,10.7 0,24ZM18.9,11.5L29.1,11.5C30.5,11.7 31.3,11.8 32.1,12.1C33,12.5 33.6,12.9 34.3,13.6C35,14.3 35.5,15.1 35.8,15.8C36.1,16.6 36.4,17.4 36.4,18.8L36.4,29C36.3,30.4 36.1,31.2 35.8,32C35.4,32.9 35,33.5 34.3,34.2C33.6,34.9 32.8,35.4 32.1,35.7C31.3,36 30.5,36.3 29.1,36.3L18.9,36.3C17.5,36.2 16.7,36 15.9,35.7C15,35.3 14.4,34.9 13.7,34.2C13,33.5 12.5,32.7 12.2,32C11.9,31.3 11.6,30.4 11.6,29L11.6,18.9C11.8,17.5 11.9,16.7 12.2,15.9C12.6,15 13,14.4 13.7,13.7C14.4,13 15.2,12.5 15.9,12.2C16.7,11.9 17.5,11.5 18.9,11.5Z',
  ],
};

export const xIconPinterest: IconDefinition = {
  prefix: 'fal',
  iconName: 'pinterest',
  icon: [
    48,
    48,
    [],
    '',
    'M0,24C0,37.3 10.7,48 24,48C37.3,48 48,37.3 48,24C48,10.7 37.3,0 24,0C10.7,0 0,10.7 0,24ZM12,24C12,17.4 17.4,12 24,12C30.6,12 36,17.4 35.8,23.4C35.8,30 30.4,35.4 23.8,35.4C22.6,35.4 21.4,35.2 20.4,34.9C20.8,34.1 21.3,33.3 21.6,32.4C21.8,31.8 22.5,29.1 22.5,29.1C23,29.9 24.2,30.6 25.5,30.6C29.4,30.6 31.9,27 31.9,22.4C31.9,18.8 28.9,15.5 24.3,15.5C18.6,15.5 15.7,19.5 15.7,23C15.7,25.1 16.5,26.9 18.1,27.6C18.4,27.8 18.5,27.6 18.7,27.3C18.9,27.2 19,26.5 19,26.4C19.1,26.2 19.1,26.1 19,26C19,25.9 18.9,25.9 18.9,25.8C18.4,25.2 18.1,24.4 18.1,23.4C18.1,20.4 20.3,17.7 23.9,17.7C27.1,17.7 28.8,19.7 28.8,22.3C28.8,25.9 27.3,28.8 25,28.8C23.6,28.8 22.8,27.7 23.1,26.6C23.2,26 23.4,25.3 23.6,24.7C23.9,23.8 24.1,23 24.1,22.4C24.1,21.4 23.5,20.6 22.5,20.6C21.3,20.6 20.3,22 20.3,23.8C20.3,25 20.7,25.8 20.7,25.8C20.7,25.8 19.5,31.3 19.2,32.4C19.1,33.3 19.1,34.2 19.1,35.1C15,33.1 12,28.9 12,24Z',
  ],
};

export const xIconTiktok: IconDefinition = {
  prefix: 'fal',
  iconName: 'tiktok',
  icon: [
    48,
    48,
    [],
    '',
    'M24,0C10.7,0,0,10.7,0,24s10.7,24,24,24s24-10.7,24-24S37.3,0,24,0z M28.7,12c0,0.4,0,0.7,0.1,1  c0.3,1.6,1.2,2.9,2.5,3.8c0.9,0.6,2,0.9,3.1,0.9v0.9v3.2c-2.1,0-4.1-0.7-5.7-1.8v8.4c0,4.2-3.4,7.6-7.6,7.6c-1.6,0-3.1-0.5-4.3-1.4  c-2-1.4-3.2-3.6-3.2-6.2c0-4.2,3.4-7.6,7.6-7.6c0.4,0,0.7,0,1,0.1v1l0,0l0,0v3.2c-0.3-0.1-0.7-0.2-1-0.2c-1.9,0-3.5,1.6-3.5,3.5  c0,1.3,0.8,2.5,1.9,3.1l0,0l0,0c0,0,0,0,0-0.1c0.5,0.3,1,0.4,1.6,0.4c1.9,0,3.4-1.5,3.5-3.3V12C24.7,12,28.7,12,28.7,12z',
  ],
};

export const xIconTwitter: IconDefinition = {
  prefix: 'fal',
  iconName: 'twitter',
  icon: [
    48,
    48,
    [],
    '',
    'M0,24C0,37.3 10.7,48 24,48C37.3,48 48,37.3 48,24C48,10.7 37.3,0 24,0C10.7,0 0,10.7 0,24ZM33.2,17.2C34.2,17 35.1,16.9 36,16.4C35.4,17.4 34.5,18.4 33.4,18.9C33.7,25.9 28.6,33.6 19.5,33.6C16.8,33.6 14.3,32.7 12,31.4C14.5,31.7 17.2,31 19,29.6C16.8,29.6 15,28.1 14.4,26.2C15.2,26.4 15.9,26.2 16.7,26C14.4,25.4 12.8,23.3 12.8,21.1C13.6,21.4 14.3,21.7 15,21.7C12.9,20.2 12.2,17.4 13.5,15.1C16,18.1 19.7,20 23.7,20.2C22.9,17.2 25.3,14.2 28.5,14.2C29.8,14.2 31.2,14.8 32.1,15.7C33.3,15.4 34.3,15.1 35.3,14.5C34.9,15.8 34.2,16.7 33.2,17.2Z',
  ],
};

export const xIconYouTube: IconDefinition = {
  prefix: 'fal',
  iconName: 'youtube',
  icon: [
    48,
    48,
    [],
    '',
    'M0,24C0,37.3 10.7,48 24,48C37.3,48 48,37.3 48,24C48,10.7 37.3,0 24,0C10.7,0 0,10.7 0,24ZM33.3,16C34.3,16.3 35.1,17 35.4,18.1C36,20.1 36,24 36,24C36,24 36,27.9 35.6,29.8C35.3,30.9 34.5,31.6 33.5,31.9C31.6,32.4 24.1,32.4 24.1,32.4C24.1,32.4 16.4,32.4 14.6,31.9C13.6,31.6 12.8,30.9 12.5,29.8C12,27.9 12,24 12,24C12,24 12,20.1 12.3,18.2C12.6,17.1 13.4,16.4 14.4,16.1C16.3,15.7 23.8,15.7 23.8,15.7C23.8,15.7 31.5,15.6 33.3,16ZM27.9,24L21.6,20.4L21.6,27.6L27.9,24Z',
  ],
};

export const xWhatsApp: IconDefinition = {
  prefix: 'fal',
  iconName: 'whatsapp',
  icon: [
    24,
    24,
    [],
    '',
    'M12,23.1c-2.1,0-4.1-0.6-5.9-1.7l-3.7,1.2c-0.3,0.1-0.6,0-0.8-0.2S1.3,22,1.4,21.7l1.2-3.5  c-1.2-1.8-1.9-4-1.9-6.3C0.7,5.7,5.8,0.7,12,0.7c0,0,0,0,0.1,0c6.2,0,11.2,5,11.3,11.2c0,2.2-0.7,4.3-1.9,6.1  c-1.7,2.5-4.2,4.3-7.2,4.9C13.5,23.1,12.7,23.1,12,23.1z M6.2,19.9c0.1,0,0.3,0,0.4,0.1c2.2,1.4,4.8,1.9,7.4,1.4  c2.6-0.5,4.8-2,6.2-4.2c1-1.6,1.6-3.4,1.6-5.3c0-5.4-4.4-9.7-9.8-9.7c0,0,0,0,0,0c0,0,0,0,0,0c-5.4,0-9.7,4.4-9.8,9.7  c0,2,0.7,4,1.9,5.7c0.1,0.2,0.2,0.5,0.1,0.7l-0.8,2.5L6,19.9C6,19.9,6.1,19.9,6.2,19.9z M14.5,18.2c-0.1,0-0.3,0-0.4,0  c-3.2-0.2-6.9-3-8.1-6.1c-0.8-2-0.4-3.9,1-5.4C7.4,6.1,8.2,6,8.8,6.1C9.4,6.2,9.9,6.6,10.1,7c0.1,0.2,0.2,0.4,0.3,0.6  c0.2,0.4,0.5,1.1,0.6,1.3c0.3,0.5,0.3,0.9,0.1,1.3c-0.1,0.2-0.2,0.3-0.4,0.5c0,0-0.1,0.1-0.2,0.2c0.8,1.2,1.9,2.2,3.3,2.8  c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.4,0.7-0.8,1.5-0.4c0.2,0.1,0.8,0.3,1.7,0.8l0.4,0.2c0.3,0.1,0.6,0.3,0.7,0.6c0,0.1,0.1,0.1,0.1,0.2  c0.2,0.6,0.1,1.3-0.3,1.8C17.4,17.5,16.1,18.2,14.5,18.2z M8.5,7.6c-0.2,0-0.4,0-0.4,0.1C7,8.7,6.8,10,7.4,11.5c1,2.5,4.2,5,6.8,5.2  c1.2,0.1,2.1-0.3,2.7-1.3c0.1-0.2,0.1-0.3,0.1-0.4c0,0,0,0-0.1,0l-0.4-0.2c-0.3-0.2-1.1-0.5-1.4-0.7c-0.2,0.3-0.4,0.6-0.6,0.7  c-0.2,0.3-0.7,0.6-1.5,0.2c-1.7-0.7-3.2-2-4.2-3.6C8.7,11,8.6,10.5,9.1,9.9c0.2-0.2,0.3-0.3,0.4-0.4C9.4,9.3,9.2,8.9,8.9,8.2  C8.8,8,8.8,7.8,8.7,7.6C8.7,7.6,8.6,7.6,8.5,7.6z',
  ],
};

const xIconPlus: IconDefinition = {
  prefix: 'fal',
  iconName: 'plus',
  icon: [
    48,
    48,
    [],
    '',
    'M24,48c-0.8,0-1.5-0.7-1.5-1.5v-21h-21C0.7,25.5,0,24.8,0,24s0.7-1.5,1.5-1.5h21v-21C22.5,0.7,23.2,0,24,0  s1.5,0.7,1.5,1.5v21h21c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5h-21v21C25.5,47.3,24.8,48,24,48z',
  ],
};

const xIconDown: IconDefinition = {
  prefix: 'fal',
  iconName: 'chevron-down',
  icon: [
    48,
    48,
    [],
    '',
    'M24,38c-0.8,0-1.6-0.3-2.1-0.9L0.4,15.7c-0.6-0.6-0.6-1.5,0-2.1C1,13,2,13,2.6,13.6L24,35l21.4-21.4  c0.6-0.6,1.5-0.6,2.1,0s0.6,1.5,0,2.1L26.1,37.1C25.6,37.7,24.8,38,24,38C24,38,24,38,24,38z',
  ],
};

const xIconLeft: IconDefinition = {
  prefix: 'fal',
  iconName: 'chevron-left',
  icon: [
    48,
    48,
    [],
    '',
    'M32.5,48c-0.4,0-0.8-0.1-1.1-0.4L10,26.1c-0.6-0.6-0.9-1.3-0.9-2.1c0-0.8,0.3-1.6,0.9-2.1L31.4,0.4  c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1L12.1,24l21.4,21.4c0.6,0.6,0.6,1.5,0,2.1C33.3,47.9,32.9,48,32.5,48z',
  ],
};

const xChevronsRight: IconDefinition = {
  prefix: 'fal',
  iconName: 'chevrons-right',
  icon: [
    24,
    24,
    [],
    '',
    'M12.1,23.3c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1l10-10l-10-10c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l10,10c0.6,0.6,0.6,1.5,0,2.1L12.7,23.1C12.5,23.2,12.3,23.3,12.1,23.3z M2.1,23.1L12.2,13c0.6-0.6,0.6-1.5,0-2.1l-10-10c-0.3-0.3-0.8-0.3-1.1,0S0.8,1.7,1.1,2l10,10l-10,10c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2S2,23.2,2.1,23.1z',
  ],
};

const xChevronsLeft: IconDefinition = {
  prefix: 'fal',
  iconName: 'chevrons-left',
  icon: [
    24,
    24,
    [],
    '',
    'M11.9,23.3c0.2,0,0.4-0.1,0.5-0.2c0.3-0.3,0.3-0.8,0-1.1l-10-10l10-10c0.3-0.3,0.3-0.8,0-1.1s-0.8-0.3-1.1,0l-10,10c-0.6,0.6-0.6,1.5,0,2.1l10.1,10.1C11.5,23.2,11.7,23.3,11.9,23.3z M21.9,23.1L11.8,13c-0.6-0.6-0.6-1.5,0-2.1l10-10c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1l-10,10l10,10c0.3,0.3,0.3,0.8,0,1.1c-0.1,0.1-0.3,0.2-0.5,0.2S22,23.2,21.9,23.1z',
  ],
};

const xIconUp: IconDefinition = {
  prefix: 'fal',
  iconName: 'chevron-up',
  icon: [
    48,
    48,
    [],
    '',
    'M46.5,35.9c-0.4,0-0.8-0.1-1.1-0.4L24,14L2.6,35.4C2,36,1,36,0.4,35.4s-0.6-1.5,0-2.1l21.4-21.4  c0.6-0.6,1.3-0.9,2.1-0.9c0,0,0,0,0,0c0.8,0,1.6,0.3,2.1,0.9l21.4,21.4c0.6,0.6,0.6,1.5,0,2.1C47.3,35.7,46.9,35.9,46.5,35.9z',
  ],
};

const xIconRight: IconDefinition = {
  prefix: 'fal',
  iconName: 'chevron-right',
  icon: [
    48,
    48,
    [],
    '',
    'M11,48c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1L31.4,24L9.9,2.6C9.4,2,9.4,1,9.9,0.4s1.5-0.6,2.1,0  l21.4,21.4c0.6,0.6,0.9,1.3,0.9,2.1c0,0.8-0.3,1.6-0.9,2.1L12.1,47.6C11.8,47.9,11.4,48,11,48z',
  ],
};

const xIconShoppingBag: IconDefinition = {
  prefix: 'fal',
  iconName: 'shopping-bag',
  icon: [
    48,
    48,
    [],
    '',
    'M6.4,47.9c-0.2,0-0.4,0-0.5,0c-2.7-0.4-4.5-2.8-4.1-5.5L6,17.3c0.2-2.4,2.1-4.3,4.6-4.4l4,0V9.7  c0-3,1.2-5.7,3.3-7.4c1.7-1.4,3.9-2.2,6.1-2.2c0,0,0,0,0,0c0,0,0,0,0,0c2.2,0,4.4,0.8,6.1,2.2c2.1,1.7,3.3,4.4,3.3,7.4v3.1h4  c0,0,0,0,0.1,0c2.4,0.1,4.4,2,4.6,4.4l4.2,25c0,0.2,0,0.3,0,0.5c0.1,2.7-1.9,5-4.6,5.1L6.4,47.9z M10.6,16c-0.8,0-1.4,0.7-1.5,1.5  c0,0.1,0,0.1,0,0.2L4.9,42.8c-0.1,0.9,0.5,1.7,1.4,1.8c0,0,0.1,0,0.1,0l35.1,0c0.8,0,1.5-0.8,1.5-1.7c0,0,0-0.1,0-0.1l-4.2-25.1  c0-0.1,0-0.1,0-0.2c0-0.8-0.7-1.5-1.5-1.5H10.6z M24,3.3C24,3.3,24,3.3,24,3.3c-1.5,0-2.9,0.5-4.1,1.5c-1.4,1.1-2.2,2.9-2.2,4.9v3.1  l12.5,0V9.7c0-2-0.8-3.8-2.2-4.9C26.9,3.8,25.5,3.3,24,3.3C24,3.3,24,3.3,24,3.3z',
  ],
};

const xIconMapPin: IconDefinition = {
  prefix: 'fal',
  iconName: 'map-pin',
  icon: [
    48,
    48,
    [],
    '',
    'M24,48c-0.5,0-1-0.1-1.5-0.4c-4.2-2.4-18.1-11.5-18.1-28C4.4,8.7,13.2,0,24,0s19.6,8.7,19.6,19.6  c0,16.4-13.9,25.6-18.1,28C25,47.9,24.5,48,24,48z M24,3C14.9,3,7.4,10.4,7.4,19.6C7.4,23.3,8.6,36.3,24,45  c15.4-8.7,16.6-21.7,16.6-25.4C40.6,10.4,33.1,3,24,3z M24,28.4c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S29,28.4,24,28.4z M24,13.4  c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S27.3,13.4,24,13.4z',
  ],
};

const xIconUser: IconDefinition = {
  prefix: 'fal',
  iconName: 'user',
  icon: [
    48,
    48,
    [],
    '',
    'M39.5,47.7c-0.8,0-1.4-0.6-1.4-1.4c0-9.4-7.6-17-17-17s-17,7.6-17,17c0,0.8-0.6,1.4-1.4,1.4S1.1,47,1.1,46.2  c0-11,8.9-19.9,19.9-19.9s19.9,8.9,19.9,19.9C40.9,47,40.2,47.7,39.5,47.7z M21,23.1c-6.3,0-11.4-5.1-11.4-11.4S14.7,0.3,21,0.3  s11.4,5.1,11.4,11.4S27.3,23.1,21,23.1z M21,3.2c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S25.7,3.2,21,3.2z',
  ],
};

const xIconSearh: IconDefinition = {
  prefix: 'fal',
  iconName: 'search',
  icon: [
    48,
    48,
    [],
    '',
    'M46.5,48c-0.4,0-0.8-0.1-1.1-0.4l-13-13c-1.5,1.3-3.2,2.4-5.1,3.2c-10,4.2-21.5-0.4-25.7-10.4l0,0  C-2.7,17.3,2,5.8,11.9,1.6c4.8-2.1,10.2-2.1,15-0.1c4.9,2,8.7,5.7,10.7,10.5c2,4.8,2.1,10.2,0.1,15c-0.8,2-1.9,3.8-3.3,5.4l13,13  c0.6,0.6,0.6,1.5,0,2.1C47.3,47.9,46.9,48,46.5,48z M4.3,26.1c3.6,8.4,13.4,12.4,21.8,8.8c1.9-0.8,3.7-2,5.1-3.4  c0,0,0.1-0.1,0.1-0.1s0.1-0.1,0.1-0.1c1.5-1.5,2.7-3.4,3.5-5.4c1.7-4.1,1.6-8.6-0.1-12.7c-1.7-4.1-5-7.3-9.1-8.9  c-4.1-1.7-8.6-1.6-12.7,0.1C4.7,7.9,0.7,17.7,4.3,26.1L4.3,26.1z',
  ],
};

const xIconCheck: IconDefinition = {
  prefix: 'fal',
  iconName: 'check',
  icon: [
    48,
    48,
    [],
    '',
    'M12.8,48c-1.2,0-2.4-0.4-3.4-1.1c-0.5-0.4-1-0.8-1.4-1.3L0.3,35.4c-0.6-0.7-0.4-1.8,0.3-2.4  c0.7-0.6,1.8-0.4,2.4,0.3l7.6,10.2c0.2,0.2,0.4,0.4,0.6,0.6c0.6,0.4,1.3,0.6,2,0.4c0.7-0.1,1.3-0.5,1.7-1.1L44.9,0.7  c0.5-0.8,1.6-0.9,2.3-0.4c0.8,0.5,0.9,1.6,0.4,2.3L17.8,45.4c-0.9,1.3-2.3,2.2-3.9,2.5C13.5,48,13.1,48,12.8,48z',
  ],
};

const xIconCheckCircle: IconDefinition = {
  prefix: 'fal',
  iconName: 'check-circle',
  icon: [
    512,
    512,
    [],
    '',
    'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z',
  ],
};

const xIconTrash: IconDefinition = {
  prefix: 'fal',
  iconName: 'trash',
  icon: [
    48,
    48,
    [],
    '',
    'M13.2,47.5c-2.3,0-4.3-1.8-4.5-4.1L6.1,11.5H2c-0.8,0-1.5-0.7-1.5-1.5S1.2,8.5,2,8.5h13V5c0-2.5,2-4.5,4.5-4.5  h9C31,0.5,33,2.5,33,5v3.5h13c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5h-4.1l-2.7,31.9c-0.2,2.3-2.1,4.1-4.5,4.1c0,0,0,0,0,0H13.2  C13.3,47.5,13.3,47.5,13.2,47.5z M13.3,44.5h21.5c0,0,0,0,0,0c0.8,0,1.4-0.6,1.5-1.4c0,0,0,0,0,0l2.6-31.6H9.1l2.6,31.6  C11.8,43.9,12.5,44.5,13.3,44.5C13.3,44.5,13.3,44.5,13.3,44.5z M18,8.5h12V5c0-0.8-0.7-1.5-1.5-1.5h-9C18.7,3.5,18,4.2,18,5V8.5z   M28.5,37c-0.8,0-1.5-0.7-1.5-1.5v-15c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v15C30,36.3,29.3,37,28.5,37z M19.5,37  c-0.8,0-1.5-0.7-1.5-1.5v-15c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v15C21,36.3,20.3,37,19.5,37z',
  ],
};

const xIconShare: IconDefinition = {
  prefix: 'fal',
  iconName: 'share',
  icon: [
    48,
    48,
    [],
    '',
    'M37.5,45c-5,0-9-4-9-9c0-0.9,0.1-1.8,0.4-2.6l-11.1-5.6c-1.6,2.2-4.3,3.7-7.3,3.7c-5,0-9-4-9-9c0-5,4-9,9-9  c3.3,0,6.2,1.8,7.7,4.4l10.5-4.1c-0.1-0.6-0.2-1.2-0.2-1.8c0-5,4-9,9-9s9,4,9,9s-4,9-9,9c-3.3,0-6.2-1.8-7.7-4.4l-10.5,4.1  c0.1,0.6,0.2,1.2,0.2,1.8c0,0.9-0.1,1.8-0.4,2.6l11.1,5.6c1.6-2.2,4.3-3.7,7.3-3.7c5,0,9,4,9,9S42.5,45,37.5,45z M37.5,30  c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S40.8,30,37.5,30z M10.5,16.5c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S13.8,16.5,10.5,16.5z   M37.5,6c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S40.8,6,37.5,6z',
  ],
};

const xIconBars: IconDefinition = {
  prefix: 'fal',
  iconName: 'bars',
  icon: [
    48,
    48,
    [],
    '',
    'M46.3,39.4H1.7c-0.9,0-1.7-0.8-1.7-1.7C0,36.8,0.8,36,1.7,36h44.6c0.9,0,1.7,0.8,1.7,1.7  C48,38.6,47.2,39.4,46.3,39.4z M46.3,25.7H1.7C0.8,25.7,0,24.9,0,24s0.8-1.7,1.7-1.7h44.6c0.9,0,1.7,0.8,1.7,1.7  S47.2,25.7,46.3,25.7z M46.3,12H1.7C0.8,12,0,11.2,0,10.3s0.8-1.7,1.7-1.7h44.6c0.9,0,1.7,0.8,1.7,1.7S47.2,12,46.3,12z',
  ],
};

const xIconHome: IconDefinition = {
  prefix: 'fal',
  iconName: 'home',
  icon: [
    48,
    48,
    [],
    '',
    'M40.5,45.9h-12c-0.8,0-1.5-0.7-1.5-1.5v-12c0-0.8-0.7-1.5-1.5-1.5h-3c-0.8,0-1.5,0.7-1.5,1.5v12  c0,0.8-0.7,1.5-1.5,1.5h-12c-0.8,0-1.5-0.7-1.5-1.5V27.9c0-0.8,0.7-1.5,1.5-1.5S9,27.1,9,27.9v15h9V32.4c0-2.5,2-4.5,4.5-4.5h3  c2.5,0,4.5,2,4.5,4.5v10.5h9v-15c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v16.5C42,45.2,41.3,45.9,40.5,45.9z M46.5,26.4  c-0.4,0-0.8-0.1-1.1-0.4L25.1,5.7c0,0-0.1-0.1-0.1-0.1c-0.3-0.3-0.8-0.5-1.2-0.4c-0.3,0-0.6,0.2-0.9,0.4c0,0-0.1,0.1-0.1,0.1  L2.6,25.9c-0.6,0.6-1.5,0.6-2.1,0s-0.6-1.5,0-2.1L20.8,3.4c0.5-0.5,1-0.8,1.6-1c0.5-0.2,1-0.3,1.6-0.3c0,0,0,0,0,0  c1.2,0,2.3,0.5,3.2,1.3l20.4,20.4c0.6,0.6,0.6,1.5,0,2.1C47.3,26.2,46.9,26.4,46.5,26.4z',
  ],
};

const xIconTimes: IconDefinition = {
  prefix: 'fal',
  iconName: 'times',
  icon: [
    44,
    44,
    [],
    '',
    'M45.8,47.9c-0.6,0-1.2-0.1-1.6-0.6L24.1,27L3.9,47.3c-0.9,0.9-2.2,0.9-3,0c-0.9-0.9-0.9-2.2,0-3L21,24L0.7,3.8  c-0.9-0.9-0.9-2.2,0-3s2.2-0.9,3,0L24.1,21L44.2,0.7c0.9-0.9,2.2-0.9,3,0c0.9,0.9,0.9,2.2,0,3L27.1,24l20.2,20.2  c0.9,0.9,0.9,2.2,0,3C47,47.8,46.4,47.9,45.8,47.9z',
  ],
};

const xIconMapMarkerAlt: IconDefinition = {
  prefix: 'fal',
  iconName: 'map-marker-alt',
  icon: [
    48,
    48,
    [],
    '',
    'M47.89,13.44h0c-.4-1-1.55-1.49-2.55-1.09l-8.31,3.46c-.35-.39-.7-.79-1.07-1.16l7.02-6.95c.63-.74,.63-1.81,0-2.55-.7-.83-1.95-.91-2.76-.21l-6.97,7.01c-.4-.37-.81-.74-1.21-1.11l3.44-8.11h0c.4-1-.09-2.14-1.11-2.55-.04,0-.07-.04-.11-.05-1.02-.39-2.14,.12-2.53,1.12l-1.51,3.76s-.67,1.62-1.32,3.18c-.61-.47-1.25-.95-1.88-1.42-1.83-1.12-4.2-.65-5.44,1.11l-.88,1.46c-.14,.18-.14,.42,0,.61l8.6,8.59c.58,.58,.58,1.51,0,2.07-.58,.58-1.51,.58-2.07,0l-7.83-7.83c-.11-.11-.26-.16-.4-.14-.16,0-.28,.11-.35,.23L.73,42.03c-1.09,1.46-.95,3.49,.35,4.78,.68,.68,1.63,1.09,2.6,1.07,.76,0,1.49-.23,2.09-.68l13.22-8.08c.12-.07,.21-.21,.23-.35,0-.16-.04-.3-.14-.4l-4.09-4.09c-.56-.6-.53-1.53,.07-2.07,.56-.53,1.44-.53,2,0l4.76,4.76c.18,.14,.44,.14,.61,0l5.46-3.27c.21-.18,.25-.47,.07-.68-.02-.04-.05-.05-.07-.07l-7.25-7.25c-.58-.58-.58-1.51,0-2.07,.56-.58,1.47-.58,2.05-.04l.04,.04,7.85,7.83c.18,.14,.42,.14,.61,0l8.76-5.36c1.65-1.21,2.14-3.44,1.18-5.23-.47-.65-.97-1.28-1.46-1.91l7.09-2.95h0c1-.4,1.49-1.55,1.09-2.55h.04Z',
  ],
};

const xIconGift: IconDefinition = {
  prefix: 'fal',
  iconName: 'gift',
  icon: [
    48,
    48,
    [],
    '',
    'M40.5,48h-33C5,48,3,46,3,43.5V24c-1.7,0-3-1.3-3-3v-4.5C0,14,2,12,4.5,12h9c-3.4-2.4-6-6.2-6-10.5  C7.5,0.7,8.2,0,9,0c6.6,0,14,5,14.9,12h0.2C25,5,32.4,0,39,0c0.8,0,1.5,0.7,1.5,1.5c0,4.3-2.5,8.1-6,10.5h9c2.5,0,4.5,2,4.5,4.5V21  c0,1.7-1.3,3-3,3v19.5C45,46,43,48,40.5,48z M30,45h10.5c0.8,0,1.5-0.7,1.5-1.5V24H30V45z M21,45h6V24h-6V45z M6,24v19.5  C6,44.3,6.7,45,7.5,45H18V24H6z M30,21h15v-4.5c0-0.8-0.7-1.5-1.5-1.5H30V21z M21,21h6v-6h-6V21z M4.5,15C3.7,15,3,15.7,3,16.5V21  h15v-6H4.5z M37.3,3.1c-4.6,0.7-9.2,4.2-10.2,8.7C31.7,11.2,36.4,7.7,37.3,3.1z M10.7,3.1c0.9,4.5,5.6,8,10.2,8.7  C19.9,7.3,15.2,3.8,10.7,3.1z',
  ],
};

const xIconTag: IconDefinition = {
  prefix: 'fal',
  iconName: 'tag',
  icon: [
    48,
    48,
    [],
    '',
    'M28.3,47.2L28.3,47.2c-0.8,0-1.6-0.3-2.1-0.9L3,23.1c-1.4-1.4-2.2-3.3-2.2-5.3V5.3c0-2.5,2-4.5,4.5-4.5h12.5  c2,0,3.9,0.8,5.3,2.2l23.3,23.3c0.4,0.4,0.7,0.9,0.8,1.5c0.3,1.6-0.7,3.2-2.4,3.5l-11.3,2.3l-2.3,11.3c-0.1,0.6-0.4,1.1-0.8,1.5  C29.9,46.9,29.1,47.2,28.3,47.2z M5.3,3.8c-0.8,0-1.5,0.7-1.5,1.5v12.5c0,1.2,0.5,2.3,1.3,3.2l23.3,23.3L30.8,32  c0.1-0.6,0.6-1.1,1.2-1.2l12.3-2.4L21,5.1c-0.9-0.8-2-1.3-3.2-1.3H5.3z M12.8,17.3c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5  s4.5,2,4.5,4.5S15.3,17.3,12.8,17.3z M12.8,11.3c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S13.6,11.3,12.8,11.3z',
  ],
};

const xIconPercent: IconDefinition = {
  prefix: 'fal',
  iconName: 'percent',
  icon: [
    48,
    48,
    [],
    '',
    'M43.5,41.5h-39C2,41.5,0,39.5,0,37v-7c0-0.8,0.7-1.5,1.5-1.5C4,28.5,6,26.5,6,24s-2-4.5-4.5-4.5  C0.7,19.5,0,18.8,0,18v-7c0-2.5,2-4.5,4.5-4.5h39c2.5,0,4.5,2,4.5,4.5v7c0,0.8-0.7,1.5-1.5,1.5c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5  c0.8,0,1.5,0.7,1.5,1.5v7C48,39.5,46,41.5,43.5,41.5z M3,31.3V37c0,0.8,0.7,1.5,1.5,1.5h39c0.8,0,1.5-0.7,1.5-1.5v-5.7  c-3.4-0.7-6-3.7-6-7.3s2.6-6.7,6-7.3V11c0-0.8-0.7-1.5-1.5-1.5h-39C3.7,9.5,3,10.2,3,11v5.7c3.4,0.7,6,3.7,6,7.3S6.4,30.7,3,31.3z   M32,34.5c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5s4.5,2,4.5,4.5S34.5,34.5,32,34.5z M32,28.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5  s1.5-0.7,1.5-1.5S32.8,28.5,32,28.5z M16.5,33c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1l15-15c0.6-0.6,1.5-0.6,2.1,0  c0.6,0.6,0.6,1.5,0,2.1l-15,15C17.3,32.9,16.9,33,16.5,33z M17.5,22.5c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5s4.5,2,4.5,4.5  S20,22.5,17.5,22.5z M17.5,16.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5S19,18.8,19,18S18.3,16.5,17.5,16.5z',
  ],
};

const xIconList: IconDefinition = {
  prefix: 'fal',
  iconName: 'list',
  icon: [
    48,
    48,
    [],
    '',
    'M6,48c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S9.3,48,6,48z M6,39c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3  S7.7,39,6,39z M46.5,43.5h-30c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h30c0.8,0,1.5,0.7,1.5,1.5S47.3,43.5,46.5,43.5z M6,30  c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S9.3,30,6,30z M6,21c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S7.7,21,6,21z M46.5,25.5h-30  c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h30c0.8,0,1.5,0.7,1.5,1.5S47.3,25.5,46.5,25.5z M6,12c-3.3,0-6-2.7-6-6s2.7-6,6-6  s6,2.7,6,6S9.3,12,6,12z M6,3C4.3,3,3,4.3,3,6s1.3,3,3,3s3-1.3,3-3S7.7,3,6,3z M46.5,7.5h-30C15.7,7.5,15,6.8,15,6s0.7-1.5,1.5-1.5  h30C47.3,4.5,48,5.2,48,6S47.3,7.5,46.5,7.5z',
  ],
};

const xIconCreditCard: IconDefinition = {
  prefix: 'fal',
  iconName: 'credit-card',
  icon: [
    48,
    48,
    [],
    '',
    'M43.5,42h-39C2,42,0,40,0,37.5v-27C0,8,2,6,4.5,6h39C46,6,48,8,48,10.5v27C48,40,46,42,43.5,42z M3,18v19.5  C3,38.3,3.7,39,4.5,39h39c0.8,0,1.5-0.7,1.5-1.5V18H3z M3,15h42v-4.5C45,9.7,44.3,9,43.5,9h-39C3.7,9,3,9.7,3,10.5V15z M21,33H10.5  C9.7,33,9,32.3,9,31.5S9.7,30,10.5,30H21c0.8,0,1.5,0.7,1.5,1.5S21.8,33,21,33z M27,27H10.5C9.7,27,9,26.3,9,25.5  c0-0.8,0.7-1.5,1.5-1.5H27c0.8,0,1.5,0.7,1.5,1.5C28.5,26.3,27.8,27,27,27z',
  ],
};

const xIconClipboardList: IconDefinition = {
  prefix: 'fal',
  iconName: 'clipboard-list',
  icon: [
    48,
    48,
    [],
    '',
    'M39,48H9c-1.2,0-2.3-0.5-3.2-1.3c-0.9-0.8-1.3-2-1.3-3.2V12c0-1.2,0.5-2.3,1.3-3.2C6.7,8,7.8,7.5,9,7.5h6.1  c0.3-1.8,1.2-3.5,2.5-4.9C19.3,0.9,21.6,0,24,0c2.4,0,4.7,0.9,6.4,2.6c1.3,1.3,2.2,3,2.5,4.9H39c1.2,0,2.3,0.5,3.2,1.3  c0.8,0.8,1.3,2,1.3,3.2v31.5c0,1.2-0.5,2.3-1.3,3.2C41.3,47.5,40.2,48,39,48z M9,10.5c-0.4,0-0.8,0.2-1.1,0.4  c-0.3,0.3-0.4,0.7-0.4,1.1v31.5c0,0.4,0.2,0.8,0.4,1.1C8.2,44.8,8.6,45,9,45h30c0.4,0,0.8-0.2,1.1-0.4s0.4-0.7,0.4-1.1V12  c0-0.4-0.2-0.8-0.4-1.1c-0.3-0.3-0.7-0.4-1.1-0.4h-7.5C30.7,10.5,30,9.8,30,9c0-1.6-0.6-3.1-1.8-4.2C27.1,3.6,25.6,3,24,3  c-1.6,0-3.1,0.6-4.2,1.8C18.6,5.9,18,7.4,18,9c0,0.8-0.7,1.5-1.5,1.5H9z M33,9L33,9L33,9z M33,37.5H15c-0.8,0-1.5-0.7-1.5-1.5  s0.7-1.5,1.5-1.5h18c0.8,0,1.5,0.7,1.5,1.5S33.8,37.5,33,37.5z M33,30H15c-0.8,0-1.5-0.7-1.5-1.5S14.2,27,15,27h18  c0.8,0,1.5,0.7,1.5,1.5S33.8,30,33,30z M33,22.5H15c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h18c0.8,0,1.5,0.7,1.5,1.5  S33.8,22.5,33,22.5z M24,10.5C24,10.5,24,10.5,24,10.5c-1.2,0-2.2-1-2.2-2.2S22.8,6,24,6c0,0,0,0,0,0c1.2,0,2.2,1,2.2,2.2  S25.2,10.5,24,10.5C24,10.5,24,10.5,24,10.5z',
  ],
};

const xIconGiftCard: IconDefinition = {
  prefix: 'fal',
  iconName: 'gift-card',
  icon: [
    48,
    48,
    [],
    '',
    'M43.5,42h-39C2,42,0,40,0,37.5v-27C0,8,2,6,4.5,6h39C46,6,48,8,48,10.5v27C48,40,46,42,43.5,42z M20.3,39h23.2  c0.8,0,1.5-0.7,1.5-1.5V26H22.1l3.8,3.8c0.6,0.6,0.6,1.5,0,2.1s-1.5,0.6-2.1,0l-3.5-3.5V39z M3,26v11.5C3,38.3,3.7,39,4.5,39h12.8  V28.5L13.9,32c-0.6,0.6-1.5,0.6-2.1,0s-0.6-1.5,0-2.1l3.8-3.8H3z M29.2,23H45V10.5C45,9.7,44.3,9,43.5,9H20.3v6.1  c0.2-0.3,0.4-0.6,0.6-0.8c2.3-2.3,6.1-2.3,8.5,0c2.3,2.3,2.3,6.1,0,8.5l0,0C29.4,22.9,29.3,22.9,29.2,23z M3,23h5.5  c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0c-2.3-2.3-2.3-6.1,0-8.5c2.3-2.3,6.1-2.3,8.5,0c0.2,0.2,0.4,0.5,0.6,0.8V9H4.5  C3.7,9,3,9.7,3,10.5V23z M25.2,15.5c-0.8,0-1.5,0.3-2.1,0.9c-0.7,0.7-1.6,3.6-2.3,6.6c2.9-0.7,5.9-1.6,6.6-2.3  c1.2-1.2,1.2-3.1,0-4.2C26.8,15.8,26,15.5,25.2,15.5z M10.4,20.7c0.7,0.7,3.6,1.6,6.6,2.3c-0.7-2.9-1.6-5.9-2.3-6.6  c-1.2-1.2-3.1-1.2-4.2,0C9.2,17.6,9.2,19.5,10.4,20.7L10.4,20.7z M28.4,21.7L28.4,21.7L28.4,21.7z',
  ],
};

const xIconLock: IconDefinition = {
  prefix: 'fal',
  iconName: 'lock',
  icon: [
    48,
    48,
    [],
    '',
    'M37.5,48h-27C8,48,6,46,6,43.5v-21C6,20,8,18,10.5,18H12v-6c0-6.6,5.4-12,12-12c6.6,0,12,5.4,12,12v6h1.5  c2.5,0,4.5,2,4.5,4.5v21C42,46,40,48,37.5,48z M10.5,21C9.7,21,9,21.7,9,22.5v21c0,0.8,0.7,1.5,1.5,1.5h27c0.8,0,1.5-0.7,1.5-1.5  v-21c0-0.8-0.7-1.5-1.5-1.5H10.5z M15,18h18v-6c0-5-4-9-9-9c-5,0-9,4-9,9V18z M24,37.5c-0.8,0-1.5-0.7-1.5-1.5v-6  c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v6C25.5,36.8,24.8,37.5,24,37.5z',
  ],
};

const xIconExclamation: IconDefinition = {
  prefix: 'fal',
  iconName: 'exclamation',
  icon: [
    48,
    48,
    [],
    '',
    'M8,44c0,2.2-1.8,4-4,4s-4-1.8-4-4,1.79-4,4-4,4,1.8,4,4Zm-1.33-12V2.67c0-1.47-1.19-2.67-2.67-2.67S1.33,1.19,1.33,2.67v29.33c0,1.47,1.19,2.67,2.67,2.67s2.67-1.19,2.67-2.67Z',
  ],
};

const xIconCircleExclamation: IconDefinition = {
  prefix: 'fal',
  iconName: 'circle-exclamation',
  icon: [
    22.52,
    22.52,
    [],
    '',
    'M11.26,22.52C5.05,22.52,0,17.47,0,11.26S5.05,0,11.26,0s11.26,5.05,11.26,11.26-5.05,11.26-11.26,11.26ZM11.26,1C5.6,1,1,5.6,1,11.26s4.6,10.26,10.26,10.26,10.26-4.6,10.26-10.26S16.92,1,11.26,1ZM13,16.86h-3.47c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h1.18v-5.37c0-.09-.04-.18-.1-.24s-.15-.1-.24-.1h-.84c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h.84c.36,0,.69.14.95.39.25.25.39.59.39.95v5.37h1.29c.28,0,.5.22.5.5s-.22.5-.5.5ZM10.79,7.67h0c-.51,0-.92-.41-.92-.92s.41-.92.92-.92h0c.51,0,.92.41.92.92s-.41.92-.92.92h0Z',
  ],
};

const xIconLogin: IconDefinition = {
  prefix: 'fal',
  iconName: 'sign-in',
  icon: [
    48,
    48,
    [],
    '',
    'M25.51,45.02c-2.47,0-4.95-.41-7.36-1.24-5.68-1.96-10.26-6.02-12.89-11.42-.36-.74-.05-1.64,.69-2,.75-.36,1.64-.05,2.01,.69,2.28,4.68,6.25,8.2,11.17,9.9s10.21,1.38,14.9-.9,8.2-6.25,9.9-11.17c1.7-4.92,1.38-10.21-.9-14.9-2.28-4.68-6.25-8.2-11.17-9.9-4.92-1.7-10.21-1.38-14.9,.9-3.72,1.81-6.72,4.7-8.67,8.35-.39,.73-1.3,1.01-2.03,.62-.73-.39-1.01-1.3-.62-2.03C7.9,7.7,11.35,4.37,15.65,2.28,21.05-.35,27.15-.72,32.84,1.24c5.68,1.96,10.26,6.02,12.89,11.42,2.63,5.4,3,11.51,1.04,17.19s-6.02,10.26-11.42,12.89c-3.12,1.52-6.46,2.28-9.83,2.28Zm-.01-13.51c-.38,0-.77-.15-1.06-.44-.59-.59-.59-1.54,0-2.12l4.94-4.94H1.5c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5H29.38l-4.94-4.94c-.59-.59-.59-1.54,0-2.12,.59-.59,1.54-.59,2.12,0l7.5,7.5c.14,.14,.25,.31,.32,.48,.07,.18,.12,.37,.12,.58s-.04,.4-.11,.58c-.07,.18-.18,.34-.33,.48l-7.5,7.5c-.29,.29-.68,.44-1.06,.44Z',
  ],
};

const xIconLogout: IconDefinition = {
  prefix: 'fal',
  iconName: 'sign-out',
  icon: [
    48,
    48,
    [],
    '',
    'M22.46,45.01c-3.3,0-6.65-.73-9.81-2.27C1.5,37.31-3.16,23.82,2.27,12.66,4.9,7.26,9.48,3.2,15.16,1.24c5.68-1.96,11.79-1.59,17.19,1.04,4.29,2.09,7.75,5.42,10,9.63,.39,.73,.11,1.64-.62,2.03-.73,.39-1.64,.11-2.03-.62-1.95-3.65-4.95-6.54-8.67-8.35C21.36,.27,9.67,4.31,4.97,13.98c-2.28,4.68-2.6,9.97-.9,14.9,1.7,4.92,5.21,8.89,9.9,11.17,9.67,4.71,21.36,.67,26.07-9,.36-.75,1.26-1.05,2-.69,.75,.36,1.05,1.26,.69,2-3.89,7.99-11.92,12.65-20.27,12.65Zm.03-13.5c-.38,0-.77-.15-1.06-.44l-7.5-7.5c-.14-.14-.25-.31-.32-.48-.07-.18-.11-.37-.11-.58s.04-.4,.11-.58c.07-.18,.18-.34,.32-.48l7.5-7.5c.59-.59,1.54-.59,2.12,0,.59,.59,.59,1.54,0,2.12l-4.94,4.94h27.88c.83,0,1.5,.67,1.5,1.5s-.67,1.5-1.5,1.5H18.61l4.94,4.94c.59,.59,.59,1.54,0,2.12-.29,.29-.68,.44-1.06,.44Z',
  ],
};

const xIconQuestion: IconDefinition = {
  prefix: 'fal',
  iconName: 'question',
  icon: [
    48,
    48,
    [],
    '',
    'M24,48C10.8,48,0,37.2,0,24S10.8,0,24,0s24,10.8,24,24S37.2,48,24,48z M24,3C12.4,3,3,12.4,3,24  c0,11.6,9.4,21,21,21c11.6,0,21-9.4,21-21C45,12.4,35.6,3,24,3z M24,37.5C24,37.5,24,37.5,24,37.5c-1.2,0-2.2-1-2.2-2.2  s1-2.2,2.2-2.2c0,0,0,0,0,0c1.2,0,2.2,1,2.2,2.2S25.2,37.5,24,37.5C24,37.5,24,37.5,24,37.5z M24,30c-0.8,0-1.5-0.7-1.5-1.5v-2  c0-0.9,0.3-1.8,0.8-2.6s1.3-1.3,2.2-1.6c0.8-0.3,1.5-0.8,2-1.4s0.9-1.4,1-2.2c0.1-0.8,0-1.7-0.3-2.4c-0.3-0.8-0.9-1.4-1.5-1.9  c-0.7-0.5-1.5-0.8-2.3-0.8c-0.8-0.1-1.6,0.1-2.4,0.5c-0.7,0.4-1.3,1-1.8,1.7s-0.7,1.5-0.7,2.3c0,0.8-0.7,1.5-1.5,1.5  s-1.5-0.7-1.5-1.5c0-1.4,0.4-2.7,1.1-3.9c0.7-1.2,1.7-2.1,3-2.8c1.2-0.6,2.6-0.9,4-0.8c1.4,0.1,2.7,0.6,3.8,1.4  c1.1,0.8,2,1.9,2.6,3.1c0.5,1.3,0.7,2.6,0.5,4c-0.2,1.4-0.7,2.6-1.6,3.7c-0.9,1.1-2,1.9-3.3,2.3c-0.3,0.1-0.5,0.3-0.7,0.5  c-0.2,0.3-0.3,0.6-0.3,0.9v2C25.5,29.3,24.8,30,24,30z',
  ],
};

const xIconPhone: IconDefinition = {
  prefix: 'fal',
  iconName: 'phone',
  icon: [
    48,
    48,
    [],
    '',
    'M36.1,48c-2.3,0-4.7-0.7-6.8-2c0,0,0,0-0.1,0C18.5,38.7,9.3,29.6,2,18.8C-1.2,13.7-0.5,7.3,3.7,3.1l1.5-1.5  c2-2,5.3-2,7.3,0l6.5,6.5c0,0,0,0,0,0c2,2,2,5.3,0,7.3c-0.9,0.9-0.9,2.2,0,3.1l10.4,10.4c0.4,0.4,1,0.6,1.5,0.6h0  c0.6,0,1.1-0.2,1.5-0.6c2-2,5.3-2,7.3,0l6.5,6.5c2,2,2,5.3,0,7.3l-1.5,1.5C42.5,46.8,39.3,48,36.1,48z M30.9,43.5  c3.9,2.4,8.7,1.9,11.9-1.3l1.5-1.5c0.9-0.9,0.9-2.2,0-3.1l-6.5-6.5c-0.9-0.9-2.2-0.9-3.1,0c-2,2-5.3,2-7.3,0L17,20.6  c-2-2-2-5.3,0-7.3c0.9-0.9,0.9-2.2,0-3.1c0,0,0,0,0,0l-6.5-6.5c-0.9-0.9-2.2-0.9-3.1,0L5.8,5.2c-3.2,3.2-3.7,8.1-1.3,11.9  C11.6,27.6,20.4,36.5,30.9,43.5z',
  ],
};

const xIconFreshDesk: IconDefinition = {
  prefix: 'fal',
  iconName: 'message',
  icon: [
    48,
    48,
    [],
    '',
    'M33.6,21.6c0,0.8-0.7,1.5-1.5,1.5H18.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5H32C32.9,20,33.6,20.7,33.6,21.6  z M26.9,25.4h-8.4c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h8.4c0.8,0,1.5-0.7,1.5-1.5S27.8,25.4,26.9,25.4z M48,7.4l-0.2,19.4  c-0.6,5.5-3.1,10.5-7,14.4C36.3,45.6,30.3,48,24,48C10.8,48,0,37.2,0,24c0-6.3,2.4-12.3,6.9-16.8c3.9-4,8.8-6.4,14.3-7L23.4,0  l17.1,0C44.7,0,48,3.3,48,7.4z M40.6,3H23.8l-0.2,0C18,3.2,12.9,5.4,9,9.3C5.1,13.3,3,18.5,3,24c0,11.6,9.4,21,21,21  c5.5,0,10.7-2.1,14.7-6c3.9-3.9,6.2-9,6.3-14.5l0-0.3V7.4C45,5,43,3,40.6,3z M38.8,21.5v5.8c0,4-3.2,7.2-7.2,7.2H15  c-1.7,0-3.1-1.4-3.1-3.1v-9.7c0-4.3,3.5-7.7,7.7-7.7h11.6C35.4,13.9,38.8,17.3,38.8,21.5z M31.2,17H19.6C17,17,15,19.1,15,21.7v9.7  l16.6,0c2.3,0,4.1-1.8,4.1-4.1v-5.8C35.7,19,33.7,17,31.2,17z',
  ],
};

const xIconEmail: IconDefinition = {
  prefix: 'fal',
  iconName: 'envelope',
  icon: [
    48,
    48,
    [],
    '',
    'M46.4,41.6H1.6C0.7,41.6,0,40.9,0,40V8c0-0.9,0.7-1.6,1.6-1.6h44.8C47.3,6.4,48,7.1,48,8v32  C48,40.9,47.3,41.6,46.4,41.6z M3.2,38.4h41.6V11.9L29.3,23.8c-3.1,2.4-7.4,2.4-10.6,0L3.2,11.9V38.4z M5.5,9.6l15.2,11.7  c2,1.5,4.7,1.5,6.7,0L42.5,9.6H5.5z',
  ],
};

const xIconDelivery: IconDefinition = {
  prefix: 'fal',
  iconName: 'truck',
  icon: [
    48,
    48,
    [],
    '',
    'M37,42.5c-2.5,0-4.6-1.7-5.3-4H16.8c-0.7,2.3-2.8,4-5.3,4s-4.6-1.7-5.3-4H4.5C2,38.5,0,36.5,0,34V10  c0-2.5,2-4.5,4.5-4.5H30c2.5,0,4.5,2,4.5,4.5v4.5h6c4.1,0,7.5,3.4,7.5,7.5v12c0,2.5-2,4.5-4.5,4.5h-1.2C41.6,40.8,39.5,42.5,37,42.5  z M37,34.5c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S38.4,34.5,37,34.5z M11.5,34.5C10.1,34.5,9,35.6,9,37  s1.1,2.5,2.5,2.5S14,38.4,14,37S12.9,34.5,11.5,34.5z M42.3,35.5h1.2c0.8,0,1.5-0.7,1.5-1.5v-7.5H34.5v5.6c0.8-0.4,1.6-0.6,2.5-0.6  C39.5,31.5,41.6,33.2,42.3,35.5z M16.8,35.5h14.7v-6H3V34c0,0.8,0.7,1.5,1.5,1.5h1.7c0.7-2.3,2.8-4,5.3-4S16.1,33.2,16.8,35.5z   M25.5,26.5h6V10c0-0.8-0.7-1.5-1.5-1.5H4.5C3.7,8.5,3,9.2,3,10v16.5h4.5V16c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v10.5H15V16  c0-0.8,0.7-1.5,1.5-1.5S18,15.2,18,16v10.5h4.5V16c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5V26.5z M34.5,23.5H45V22  c0-2.5-2-4.5-4.5-4.5h-6V23.5z',
  ],
};

const xIconEFT: IconDefinition = {
  prefix: 'fal',
  iconName: 'money-bill-transfer',
  icon: [
    48,
    48,
    [],
    '',
    'M40.5,37.5c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1l3.4-3.4H21c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5  h21.9l-3.4-3.4c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l6,6c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0  c0.1,0.1,0.2,0.3,0.3,0.5C48,29.6,48,29.8,48,30c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0.2,0,0.4-0.1,0.6  c-0.1,0.2-0.2,0.3-0.3,0.5c0,0,0,0,0,0l0,0c0,0,0,0,0,0l-6,6C41.3,37.4,40.9,37.5,40.5,37.5z M7.5,25.5c-0.4,0-0.8-0.1-1.1-0.4l-6-6  c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1-0.1-0.2-0.3-0.3-0.5C0,18.4,0,18.2,0,18c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0  c0,0,0,0,0,0c0,0,0,0,0,0c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l6-6  c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-3.4,3.4H27c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5H5.1l3.4,3.4  c0.6,0.6,0.6,1.5,0,2.1C8.3,25.4,7.9,25.5,7.5,25.5z',
  ],
};

const xIconWallet: IconDefinition = {
  prefix: 'fal',
  iconName: 'google-wallet',
  icon: [
    48,
    48,
    [],
    '',
    'M37.5,47.5h-30c-2,0-3.9-0.8-5.3-2.2C0.8,43.9,0,42,0,40V19c0-2,0.8-3.9,2.2-5.3c1.3-1.3,3.1-2.1,4.9-2.2  L28.1,1c0.5-0.3,1.1-0.4,1.7-0.5c0.6,0,1.2,0,1.7,0.2c0.6,0.2,1.1,0.5,1.5,0.9C33.6,2,33.9,2.5,34.2,3l4.3,8.5  c1.6,0.2,3.2,0.9,4.3,2.1C44.2,15.1,45,17,45,19v1.8c0.6,0.2,1.2,0.6,1.7,1.1c0.9,0.9,1.3,2,1.3,3.2v9c0,1.2-0.5,2.3-1.3,3.2  c-0.5,0.5-1.1,0.8-1.7,1.1V40c0,2-0.8,3.9-2.2,5.3C41.4,46.7,39.5,47.5,37.5,47.5z M7.5,14.5c-1.2,0-2.3,0.5-3.2,1.3  C3.5,16.7,3,17.8,3,19v21c0,1.2,0.5,2.3,1.3,3.2c0.9,0.9,2,1.3,3.2,1.3h30c1.2,0,2.3-0.5,3.2-1.3c0.9-0.8,1.3-2,1.3-3.2v-1.5h-6  c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4s0.9-4.7,2.6-6.4s4-2.6,6.4-2.6h6V19c0-1.2-0.5-2.3-1.3-3.2c-0.8-0.8-2-1.3-3.2-1.3  c0,0,0,0-0.1,0H7.5C7.5,14.5,7.5,14.5,7.5,14.5z M36,23.5c-1.6,0-3.1,0.6-4.2,1.8c-1.1,1.1-1.8,2.6-1.8,4.2s0.6,3.1,1.8,4.2  c1.1,1.1,2.6,1.8,4.2,1.8h7.5c0.4,0,0.8-0.2,1.1-0.4S45,34.4,45,34v-9c0-0.4-0.2-0.8-0.4-1.1c-0.3-0.3-0.7-0.4-1.1-0.4H36z   M13.9,11.5h21.2l-3.6-7.1c-0.1-0.2-0.2-0.3-0.4-0.5c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0.1-0.6,0.2  L13.9,11.5z M36,31.8C36,31.8,36,31.8,36,31.8c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2c0,0,0,0,0,0c1.2,0,2.2,1,2.2,2.2  S37.2,31.7,36,31.8C36,31.8,36,31.8,36,31.8z',
  ],
};

const xEditPencil: IconDefinition = {
  prefix: 'fal',
  iconName: 'pen-to-square',
  icon: [
    48,
    48,
    [],
    '',
    'M35.2,48h-30c-2.5,0-4.5-2-4.5-4.5v-30C0.7,11,2.8,9,5.2,9h15c0.8,0,1.5,0.7,1.5,1.5S21.1,12,20.2,12h-15  c-0.8,0-1.5,0.7-1.5,1.5v30c0,0.8,0.7,1.5,1.5,1.5h30c0.8,0,1.5-0.7,1.5-1.5v-15c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v15  C39.7,46,37.7,48,35.2,48z M17.9,30.8c-0.4,0-0.8-0.2-1.1-0.4c-0.3-0.3-0.5-0.8-0.4-1.3l1.1-7.4c0-0.3,0.2-0.6,0.4-0.8L37,1.8  C38.1,0.6,39.6,0,41.2,0s3.1,0.6,4.2,1.8c1.1,1.1,1.8,2.6,1.8,4.2s-0.6,3.1-1.8,4.2L26.4,29.3c-0.2,0.2-0.5,0.4-0.8,0.4l-7.4,1.1  C18.1,30.8,18,30.8,17.9,30.8z M25.3,28.3L25.3,28.3L25.3,28.3z M20.4,22.6l-0.7,5l4.9-0.7L43.4,8.1c0.6-0.6,0.9-1.3,0.9-2.1  s-0.3-1.6-0.9-2.1c-1.1-1.1-3.1-1.1-4.2,0L20.4,22.6z',
  ],
};

const xArrowRotate: IconDefinition = {
  prefix: 'fal',
  iconName: 'arrows-rotate',
  icon: [
    48,
    48,
    [],
    '',
    'M24,45c-2.7,0-5.5-0.5-8.1-1.6c-0.8-0.3-1.1-1.2-0.8-2c0.3-0.8,1.2-1.1,2-0.8c6.6,2.8,14.2,1.3,19.4-3.6c6.4-6.1,7.3-15.8,2.5-22.9v5.5c0,0.8-0.7,1.5-1.5,1.5S36,20.3,36,19.5v-9C36,9.7,36.7,9,37.5,9h0.4c0.1,0,0.2,0,0.3,0h8.3c0.8,0,1.5,0.7,1.5,1.5S47.3,12,46.5,12h-5.3c5.8,8.3,4.9,19.9-2.7,27.2C34.5,43,29.3,45,24,45z M9.9,39c0,0-0.1,0-0.1,0H1.5C0.7,39,0,38.3,0,37.5S0.7,36,1.5,36h5.3C1,27.7,1.9,16.1,9.5,8.8c6-5.8,14.9-7.4,22.6-4.2c0.8,0.3,1.1,1.2,0.8,2c-0.3,0.8-1.2,1.1-2,0.8C24.3,4.6,16.7,6.1,11.6,11C5.2,17.1,4.3,26.8,9,33.9v-5.4c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v9c0,0.8-0.7,1.5-1.5,1.5h-0.4C10,39,10,39,9.9,39z',
  ],
};

const xCircleEllipsis: IconDefinition = {
  prefix: 'fal',
  iconName: 'circle-ellipsis',
  icon: [
    24,
    24,
    [],
    '',
    'M0,12c0,1.8,1.5,3.2,3.2,3.2s3.2-1.5,3.2-3.2S5,8.8,3.2,8.8S0,10.2,0,12 M8.8,12c0,1.8,1.5,3.2,3.2,3.2  s3.2-1.5,3.2-3.2S13.8,8.8,12,8.8S8.8,10.2,8.8,12 M17.5,12c0,1.8,1.5,3.2,3.2,3.2S24,13.8,24,12s-1.5-3.2-3.2-3.2  S17.5,10.2,17.5,12',
  ],
};

const xDownload: IconDefinition = {
  prefix: 'fal',
  iconName: 'download',
  icon: [
    48,
    48,
    [],
    '',
    'M40.5,42h-33C3.4,42,0,38.6,0,34.5v-3C0,30.7,0.7,30,1.5,30S3,30.7,3,31.5v3C3,37,5,39,7.5,39h33  c2.5,0,4.5-2,4.5-4.5v-3c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v3C48,38.6,44.6,42,40.5,42z M24,33C24,33,24,33,24,33  C24,33,24,33,24,33c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.3-0.2-0.5-0.3c0,0,0,0,0,0c0,0,0,0,0,0l-9-9c-0.6-0.6-0.6-1.5,0-2.1  c0.6-0.6,1.5-0.6,2.1,0l6.4,6.4V7.5C22.5,6.7,23.2,6,24,6s1.5,0.7,1.5,1.5v20.4l6.4-6.4c0.6-0.6,1.5-0.6,2.1,0  c0.6,0.6,0.6,1.5,0,2.1l-9,9c0,0,0,0,0,0l0,0c0,0,0,0,0,0c-0.1,0.1-0.3,0.2-0.5,0.3C24.4,33,24.2,33,24,33C24,33,24,33,24,33  C24,33,24,33,24,33z',
  ],
};

const xHeartAlt: IconDefinition = {
  prefix: 'fal',
  iconName: 'heart-broken',
  icon: [
    48,
    48,
    [],
    '',
    'M24,45.2c-0.4,0-0.8-0.2-1.1-0.5l-19.2-20c-3.9-3.9-4.9-9.9-2.4-14.8c1.5-3.1,4.2-5.4,7.4-6.4  c3.3-1.1,6.7-0.8,9.8,0.7c1.2,0.6,2.4,1.4,3.3,2.4L24,8.6l2.1-2.1c5-5,13.2-5,18.2,0c1,1,1.8,2.1,2.4,3.3c2.5,5,1.5,10.9-2.4,14.8  l-19.2,20C24.8,45,24.4,45.2,24,45.2z M12.9,5.8c-1,0-2.1,0.2-3.1,0.5C7.2,7.2,5.2,8.9,4,11.3c-1.9,3.8-1.2,8.4,1.8,11.4L24,41.5  l18.1-18.9c3-3,3.8-7.6,1.9-11.4c-0.5-0.9-1.1-1.8-1.8-2.6c-3.8-3.8-10.1-3.8-13.9,0l-3.1,3.1c-0.6,0.6-1.5,0.6-2.1,0l-3.1-3.1  c-0.7-0.7-1.6-1.4-2.6-1.8C15.9,6.2,14.4,5.8,12.9,5.8z',
  ],
};

const xHeart: IconDefinition = {
  prefix: 'fal',
  iconName: 'heart',
  icon: [
    48,
    48,
    [],
    '',
    'M24,45.2c-0.4,0-0.8-0.2-1.1-0.5l-19.2-20c-3.9-3.9-4.9-9.9-2.4-14.8c1.5-3.1,4.2-5.4,7.4-6.4  c3.3-1.1,6.7-0.8,9.8,0.7c1.2,0.6,2.4,1.4,3.3,2.4l2.2,2l2.1-2.1c5-5,13.2-5,18.2,0c1,1,1.8,2.1,2.4,3.3c2.5,5,1.5,10.9-2.4,14.8  l-19.2,20C24.8,45,24.4,45.2,24,45.2z',
  ],
};

const xIconLocationCrosshairs: IconDefinition = {
  prefix: 'fal',
  iconName: 'location-crosshairs',
  icon: [
    24,
    24,
    [],
    '',
    'M12,24c-0.4,0-0.8-0.3-0.8-0.8v-3c-4-0.4-7.1-3.5-7.5-7.5h-3C0.3,12.8,0,12.4,0,12s0.3-0.8,0.8-0.8h3 c0.4-4,3.5-7.1,7.5-7.5v-3C11.2,0.3,11.6,0,12,0s0.8,0.3,0.8,0.8v3c4,0.4,7.1,3.5,7.5,7.5h3c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8 h-3c-0.4,4-3.5,7.1-7.5,7.5v3C12.8,23.7,12.4,24,12,24z M12,5.2c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8c3.7,0,6.8-3,6.8-6.8 C18.8,8.3,15.7,5.2,12,5.2z M12,15.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8 C15.8,14.1,14.1,15.8,12,15.8z M12,9.8c-1.2,0-2.2,1-2.2,2.2c0,1.2,1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2C14.2,10.8,13.2,9.8,12,9.8z',
  ],
};

const xIconClock: IconDefinition = {
  prefix: 'fal',
  iconName: 'clock',
  icon: [
    24,
    24,
    [],
    '',
    'M12,23.3C5.8,23.3.8,18.2.8,12S5.8.8,12,.8s11.2,5,11.2,11.2-5,11.2-11.2,11.2ZM12,2.3C6.6,2.3,2.2,6.6,2.2,12s4.4,9.8,9.8,9.8,9.8-4.4,9.8-9.8S17.4,2.3,12,2.3ZM12.8,12v-3.8c0-.4-.3-.8-.8-.8s-.8.3-.8.8v3.8c0,.4.3.8.8.8s.8-.3.8-.8ZM17.2,17.2c.3-.3.3-.8,0-1.1l-4.7-4.7c-.3-.3-.8-.3-1.1,0s-.3.8,0,1.1l4.7,4.7c.1.1.3.2.5.2s.4,0,.5-.2Z',
  ],
};

const xIconArrowRight: IconDefinition = {
  prefix: 'fal',
  iconName: 'arrow-right',
  icon: [
    48,
    48,
    [],
    '',
    'M11,48c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1L31.4,24L9.9,2.6C9.4,2,9.4,1,9.9,0.4s1.5-0.6,2.1,0l21.4,21.4c0.6,0.6,0.9,1.3,0.9,2.1c0,0.8-0.3,1.6-0.9,2.1L12.1,47.6C11.8,47.9,11.4,48,11,48z',
  ],
};

const xIconUpRightAndDownLeftFromCenter: IconDefinition = {
  prefix: 'fal',
  iconName: 'up-right-and-down-left-from-center',
  icon: [
    20,
    20,
    [],
    '',
    'M0.256,19.987C0.199,19.971 0.146,19.94 0.102,19.894C0.032,19.821 -0.002,19.725 0,19.63L0,13.703C0,13.499 0.155,13.333 0.347,13.333C0.538,13.333 0.693,13.499 0.693,13.703L0.693,18.763L7.532,11.621C7.667,11.48 7.887,11.48 8.023,11.621C8.159,11.763 8.159,11.993 8.023,12.135L1.2,19.261L5.903,19.261C6.095,19.261 6.25,19.426 6.25,19.63C6.25,19.834 6.095,20 5.903,20C5.903,20 0.347,20 0.347,20C0.316,20 0.285,19.996 0.256,19.987ZM19.307,1.237L12.468,8.379C12.333,8.52 12.113,8.52 11.977,8.379C11.841,8.237 11.841,8.007 11.977,7.865L18.8,0.739L14.097,0.739C13.905,0.739 13.75,0.574 13.75,0.37C13.75,0.166 13.905,0 14.097,0C14.097,0 19.653,-0 19.653,0C19.685,0 19.716,0.005 19.745,0.013C19.801,0.029 19.854,0.06 19.898,0.106C19.968,0.179 20.002,0.275 20,0.37L20,6.297C20,6.501 19.845,6.667 19.653,6.667C19.462,6.667 19.307,6.501 19.307,6.297L19.307,1.237Z',
  ],
};

const xCalender: IconDefinition = {
  prefix: 'fal',
  iconName: 'calendar',
  icon: [
    48,
    48,
    [],
    '',
    'M43.5,48h-39C2,48,0,46,0,43.5v-33C0,8,2,6,4.5,6H12V1.5C12,0.7,12.7,0,13.5,0S15,0.7,15,1.5V6h18V1.5  C33,0.7,33.7,0,34.5,0S36,0.7,36,1.5V6h7.5C46,6,48,8,48,10.5v33C48,46,46,48,43.5,48z M3,21v22.5C3,44.3,3.7,45,4.5,45h39  c0.8,0,1.5-0.7,1.5-1.5V21H3z M3,18h42v-7.5C45,9.7,44.3,9,43.5,9H36v3c0,0.8-0.7,1.5-1.5,1.5S33,12.8,33,12V9H15v3  c0,0.8-0.7,1.5-1.5,1.5S12,12.8,12,12V9H4.5C3.7,9,3,9.7,3,10.5V18z',
  ],
};

export const xIconSavedCard: IconDefinition = {
  prefix: 'fal',
  iconName: 'saved-card' as IconName,
  icon: [
    512,
    512,
    [],
    '',
    'M341.3 134.4L396.8 192c2.1 2.1 6.4 4.3 10.7 4.3s8.5-2.1 10.7-4.3l55.5-59.7c10.7-4.3 14.9-14.9 17.1-25.6s0-21.3-4.3-29.9c-4.3-6.4-8.5-12.8-14.9-17.1s-12.8-8.5-21.3-8.5c-8.5-2.1-14.9 0-23.5 2.1c-6.4 2.1-12.8 6.4-17.1 10.7c-4.3-4.3-10.7-8.5-17.1-10.7s-14.9-2.1-23.5-2.1c-8.5 2.1-14.9 4.3-21.3 8.5s-12.8 10.7-14.9 17.1c-4.3 8.5-6.4 19.2-4.3 29.9c0 10.7 6.4 21.3 12.8 27.7zm19.2-42.7c0-2.1 2.1-4.3 4.3-6.4s4.3-2.1 8.5-4.3c0 0 2.1 0 2.1 0c2.1 0 4.3 0 6.4 0s4.3 2.1 6.4 4.3l8.5 8.5c6.4 6.4 14.9 6.4 21.3 0l8.5-8.5c2.1-2.1 4.3-4.3 6.4-4.3s6.4 0 8.5 0s6.4 2.1 8.5 4.3s4.3 4.3 6.4 6.4c2.1 4.3 2.1 6.4 2.1 10.7s-2.1 6.4-4.3 10.7L409.6 160l-46.9-46.9c-2.1-2.1-4.3-6.4-4.3-10.7s0-6.4 2.1-10.7zm115.2 74.7c-8.5 0-14.9 6.4-14.9 14.9v27.7H277.3c-4.3-6.4-12.8-10.7-21.3-12.8l-42.7-6.4v-6.4c0-4.3 2.1-6.4 4.3-10.7c2.1-2.1 6.4-4.3 10.7-4.3h72.5c8.5 0 14.9-6.4 14.9-14.9s-6.4-14.9-14.9-14.9h-72.5c-12.8 0-23.5 4.3-32 12.8c-10.7 8.5-14.9 19.2-14.9 32v0l-2.1 0c-4.3 0-10.7 0-14.9 4.3l-78.9 76.8s-4.3 2.1-4.3 2.1H36.3c-8.5 0-14.9 6.4-14.9 14.9s6.4 17.1 14.9 17.1h46.9c4.3 0 10.7-2.1 14.9-4.3s8.5-6.4 10.7-8.5l72.5-72.5 68.3 12.8s0 4.3 0 10.7c0 0-2.1 2.1-2.1 2.1l-36.3 4.3c-4.3 0-8.5 2.1-12.8 4.3c-4.3 4.3-6.4 8.5-10.7 10.7c-2.1 4.3-4.3 6.4-6.4 10.7c0 4.3-2.1 8.5 0 10.7v46.9c0 2.1-2.1 4.3-2.1 4.3l-40.5 32c-6.4 6.4-8.5 14.9-2.1 21.3c2.1 4.3 8.5 6.4 12.8 6.4s6.4-2.1 10.7-4.3l40.5-32c6.4-6.4 10.7-14.9 12.8-23.5c0-2.1 0-2.1 0-4.3v-49.1s2.1-2.1 2.1-2.1l36.3-4.3c6.4 0 12.8-4.3 19.2-8.5c4.3-4.3 8.5-10.7 10.7-17.1c0-2.1 0-2.1 0-4.3h179.2v100.3c0 4.3-2.1 6.4-4.3 10.7c-2.1 2.1-6.4 4.3-10.7 4.3H343.5s0 0 0 0h-85.3c-8.5 0-14.9 6.4-14.9 14.9s6.4 14.9 14.9 14.9h70.4c-4.3 29.9-21.3 42.7-55.5 42.7c-115.2 0-149.3-6.4-174.9-10.7c-17.1-2.1-29.9-4.3-59.7-4.3c-8.5 0-14.9 6.4-14.9 14.9s6.4 14.9 14.9 14.9c27.7 0 38.4 2.1 55.5 4.3c25.6 4.3 61.9 10.7 179.2 10.7c51.2 0 81.1-25.6 85.3-72.5H448c12.8 0 23.5-4.3 32-12.8s12.8-19.2 12.8-32V183.5c-2.1-8.5-8.5-17.1-17.1-17.1zM416 300.8c8.5 0 14.9-6.4 14.9-14.9s-6.4-14.9-14.9-14.9h-29.9c-8.5 0-14.9 6.4-14.9 14.9s6.4 14.9 14.9 14.9H416z',
  ],
};

export const xIconNewCard: IconDefinition = {
  prefix: 'fal',
  iconName: 'new-card' as IconName,
  icon: [
    512,
    512,
    [],
    '',
    'M469.3 266.7c-27.7-27.7-64-42.7-102.4-42.7s-74.7 14.9-102.4 42.7s-42.7 64-42.7 102.4s14.9 74.7 42.7 102.4s64 42.7 102.4 42.7s74.7-14.9 102.4-42.7s42.7-64 42.7-102.4c0-40.5-14.9-76.8-42.7-102.4zM445.9 445.9c-21.3 21.3-49.1 32-78.9 32s-57.6-10.7-78.9-32s-32-49.1-32-78.9s10.7-57.6 32-78.9 49.1-32 78.9-32s57.6 10.7 78.9 32s32 49.1 32 78.9s-10.7 57.6-32 78.9zm-268.8-128h-128c-4.3 0-8.5-2.1-10.7-4.3s-4.3-6.4-4.3-10.7V130.1h379.7v46.9c0 8.5 8.5 17.1 17.1 17.1s17.1-8.5 17.1-17.1v-128c0-12.8-4.3-25.6-14.9-34.1C424.5 6.4 411.7 0 398.9 0H49.1C36.3 0 23.5 4.3 14.9 14.9S0 36.3 0 49.1v253.9c0 12.8 4.3 25.6 14.9 34.1c8.5 8.5 21.3 14.9 34.1 14.9h128c8.5 0 17.1-8.5 17.1-17.1s-8.5-17.1-17.1-17.1zM38.4 38.4c2.1-2.1 6.4-4.3 10.7-4.3h349.9c4.3 0 8.5 2.1 10.7 4.3s4.3 6.4 4.3 10.7V96H34.1V49.1c0-4.3 2.1-8.5 4.3-10.7zM206.9 174.9h-128c-8.5 0-14.9 8.5-14.9 17.1s8.5 17.1 17.1 17.1h128c8.5 0 17.1-8.5 17.1-17.1s-8.5-17.1-19.2-17.1zm-61.9 98.1c8.5 0 17.1-8.5 17.1-17.1s-8.5-17.1-17.1-17.1h-64C70.4 238.9 64 245.3 64 256c0 8.5 8.5 17.1 17.1 17.1h64zM428.8 352h-42.7v-51.2c0-8.5-8.5-17.1-17.1-17.1s-17.1 8.5-17.1 17.1V352h-51.2c-8.5 0-17.1 8.5-17.1 17.1s8.5 17.1 17.1 17.1H352v42.7c0 8.5 8.5 17.1 17.1 17.1s17.1-8.5 17.1-17.1v-42.7h42.7c8.5 0 17.1-8.5 17.1-17.1c0-10.7-8.5-17.1-17.1-17.1z',
  ],
};

export const streamlineRegular: IconPack = {
  'new-card': xIconNewCard,
  'saved-card': xIconSavedCard,
  'arrow-right': xIconArrowRight,
  'apple-pay': xIconApplePay,
  facebook: xIconFacebook,
  instagram: xIconInstagram,
  pinterest: xIconPinterest,
  tiktok: xIconTiktok,
  twitter: xIconTwitter,
  youTube: xIconYouTube,
  plus: xIconPlus,
  down: xIconDown,
  left: xIconLeft,
  'cheverons-left': xChevronsLeft,
  'cheverons-right': xChevronsRight,
  right: xIconRight,
  up: xIconUp,
  shoppingBag: xIconShoppingBag,
  mapPin: xIconMapPin,
  user: xIconUser,
  search: xIconSearh,
  check: xIconCheck,
  checkCircle: xIconCheckCircle,
  trash: xIconTrash,
  share: xIconShare,
  bars: xIconBars,
  home: xIconHome,
  times: xIconTimes,
  mapMarkerAlt: xIconMapMarkerAlt,
  gift: xIconGift,
  tag: xIconTag,
  percent: xIconPercent,
  list: xIconList,
  creditCard: xIconCreditCard,
  clipBoardList: xIconClipboardList,
  giftCard: xIconGiftCard,
  lock: xIconLock,
  exclamation: xIconExclamation,
  login: xIconLogin,
  logout: xIconLogout,
  question: xIconQuestion,
  phone: xIconPhone,
  message: xIconFreshDesk,
  envelope: xIconEmail,
  truck: xIconDelivery,
  'money-bill-transfer': xIconEFT,
  'google-wallet': xIconWallet,
  editPencil: xEditPencil,
  whatsapp: xWhatsApp,
  'arrows-rotate': xArrowRotate,
  'circle-ellipsis': xCircleEllipsis,
  download: xDownload,
  heartAlt: xHeartAlt,
  xHeart: xHeart,
  'location-crosshairs': xIconLocationCrosshairs,
  clock: xIconClock,
  'up-right-and-down-left-from-center': xIconUpRightAndDownLeftFromCenter,
  calender: xCalender,
  'circle-exclamation': xIconCircleExclamation,
};
